import { render } from "./warehouses.vue?vue&type=template&id=5d2f281d&scoped=true"
import script from "./warehouses.vue?vue&type=script&lang=js"
export * from "./warehouses.vue?vue&type=script&lang=js"

import "./warehouses.vue?vue&type=style&index=0&id=5d2f281d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2f281d"]])

export default __exports__